import apiProxy from './api-proxy-inst';

class FileApi {
  uploadUrl() {
    return apiProxy.request('/file/upload');
  }

  downloadUrl(args) {
    return apiProxy.request('/file/download', args).then(data => {
      return data;
    });
  }

  getImageDataUrl(args) {
    // return apiProxy.request('/image_data_url/get', args).then(data => {
    //   return data;
    // });
    return apiProxy.request('/image_data_url/get', args, {
      responseType: 'text'
    });
  }

  imgSave(args) {
    return apiProxy.request('/image_data_url/save', args).then(data => {
      return data;
    });
  }
}

export default new FileApi();